import { DollarOutlined, StockOutlined } from "@ant-design/icons";
import { TrendingDown, TrendingUp } from "@mui/icons-material";

function SummaryCards({ cards }) {

    const getIcon = (icon) => {
        switch (icon) {
            case 'income':
                return <TrendingUp style={{ width: 24, height: 24 }} />;
            case 'expense':
                return <TrendingDown style={{ width: 24, height: 24 }} />;
            case 'activity':
                return <StockOutlined style={{ width: 24, height: 24 }} />;
            case 'balance':
                return <DollarOutlined style={{ width: 24, height: 24 }} />;
            default:
                return null;
        }
    };

    const getIconColor = (icon) => {
        switch (icon) {
            case 'income':
                return { backgroundColor: '#dcfce7', color: '#16a34a' };
            case 'expense':
                return { backgroundColor: '#fee2e2', color: '#dc2626' };
            case 'activity':
                return { backgroundColor: '#dbeafe', color: '#2563eb' };
            case 'balance':
                return { backgroundColor: '#f3e8ff', color: '#9333ea' };
            default:
                return {};
        }
    };

    const getTrendColor = (trend) => {
        if (trend === 'up') return { color: '#16a34a' };
        if (trend === 'down') return { color: '#dc2626' };
        return { color: '#6b7280' };
    };

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: 24,
                marginBottom: 24,
            }}
        >
            {cards.map((card, index) => (
                <div
                    key={index}
                    style={{
                        backgroundColor: '#ffffff',
                        borderRadius: 12,
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        padding: 24,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: 16,
                        }}
                    >
                        <div
                            style={{
                                padding: 12,
                                borderRadius: 8,
                                ...getIconColor(card.icon),
                            }}
                        >
                            {getIcon(card.icon)}
                        </div>

                        {card.change && (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontSize: 14,
                                    ...getTrendColor(card.trend),
                                }}
                            >
                                {card.trend === 'up' && (
                                    <TrendingUp style={{ width: 16, height: 16 }} />
                                )}
                                {card.trend === 'down' && (
                                    <TrendingDown style={{ width: 16, height: 16 }} />
                                )}
                                <span>{card.change}</span>
                            </div>
                        )}
                    </div>

                    <h3
                        style={{
                            color: '#6b7280',
                            fontSize: 14,
                            marginBottom: 4,
                        }}
                    >
                        {card.title}
                    </h3>

                    <p
                        style={{
                            fontSize: 24,
                            fontWeight: 'bold',
                            color: '#111827',
                        }}
                    >
                        {card.value}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default SummaryCards;